export default "__VITE_ASSET__CDgXU0wi__"